import React, { useState } from 'react';
import { Box, Grid, Typography, Button, Menu, MenuItem } from '@mui/material';
import { ArrowBackIosNewOutlinedIcon, AddIcon, MoreHorizOutlinedIcon, SettingsOutlinedIcon, ContentCopyOutlinedIcon, DeleteOutlineIcon } from 'icons/materialIcons';
import { useNavigate } from 'react-router-dom';
import TeamDarkButtonWithIcon from 'team/shared/components/button/TeamDarkButtonWithIcon';

const TeamTemplateEditNavbar = ({ templateName, isEditing, onSave, onCancel, isSubmitting, nextTemplateNumber, templateId, onAssignMembers, onSetAsDefault, onDuplicate, onRemove }) => {
    const navigate = useNavigate();
    const [menuAnchorEl, setMenuAnchorEl] = useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const handleBack = () => {
        navigate('/team/templates');
    };

    const handleMenuClick = (event) => {
        setMenuAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchorEl(null);
    };

    const handleSetAsDefault = () => {
        if (onSetAsDefault) {
            onSetAsDefault();
        }
        handleMenuClose();
    };

    const handleDuplicate = () => {
        if (onDuplicate) {
            onDuplicate();
        }
        handleMenuClose();
    };

    const handleRemove = () => {
        if (onRemove) {
            onRemove();
        }
        handleMenuClose();
    };

    const handleAssignMembersClick = () => {
        if (onAssignMembers) {
            onAssignMembers();
        }
    };

    return (
        <Box
            sx={{
                padding: 2,
                flexShrink: 0
            }}
        >
            <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm="auto">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            onClick={handleBack}
                            sx={{
                                minWidth: 'auto',
                                padding: 0,
                                backgroundColor: 'transparent',
                                color: '#828282',
                                '&:hover': {
                                    backgroundColor: 'transparent'
                                }
                            }}
                        >
                            <ArrowBackIosNewOutlinedIcon />
                        </Button>
                        <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            {isEditing ? (templateName || 'Untitled') : (nextTemplateNumber ? `Template ${nextTemplateNumber}` : 'Create New Template')}
                        </Typography>
                    </Box>
                </Grid>

                <Grid item xs={12} sm container justifyContent="flex-end">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <TeamDarkButtonWithIcon
                            text="Assign template"
                            icon={<AddIcon />}
                            iconPosition="start"
                            onClick={handleAssignMembersClick}
                        />
                        <Button
                            variant="contained"
                            sx={{
                                backgroundColor: '#fff',
                                color: '#cccccc',
                                fontWeight: '500',
                                borderRadius: '12px',
                                border: '1px #e0e0e0 solid',
                                textTransform: 'none',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '75px',
                                padding: '6.5px 16px',
                                boxShadow: 'none',
                                minWidth: 'auto',
                                '&:hover': {
                                    backgroundColor: '#fff',
                                    color: '#828282',
                                    boxShadow: 'none',
                                },
                            }}
                            onClick={handleMenuClick}
                        >
                            <MoreHorizOutlinedIcon sx={{ color: '#828282' }} />
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            {/* Three dots menu */}
            <Menu
                anchorEl={menuAnchorEl}
                open={menuOpen}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        minWidth: '220px',
                        marginTop: '12px', // Add space above the menu
                    }
                }}
            >
                <MenuItem onClick={handleSetAsDefault}>
                    <SettingsOutlinedIcon sx={{ marginRight: 1, fontSize: '18px' }} />
                    Set all assigned cards to default
                </MenuItem>
                <MenuItem onClick={handleDuplicate}>
                    <ContentCopyOutlinedIcon sx={{ marginRight: 1, fontSize: '18px' }} />
                    Duplicate Template
                </MenuItem>
                <MenuItem onClick={handleRemove} sx={{ color: 'error.main' }}>
                    <DeleteOutlineIcon sx={{ marginRight: 1, fontSize: '18px' }} />
                    Remove
                </MenuItem>
            </Menu>
        </Box>
    );
};

export default TeamTemplateEditNavbar;

